import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import SelectDropDownSmallBtn from '../common/button/SelectDropDownSmallBtn';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { setUserBrandDelAction, setUserBrandAllDelAction, setUserNoBrandAllDelAction, setUserNoBrandDelAction } from '../../modules/common/brandModule';
import { useDispatch, useSelector } from 'react-redux';
import { userClipSortAction } from '../../modules/su/userInfoModule';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import SelectOrderBox from '../common/button/SelectOrderBox';
import MyEsOrderBox from '../../components/es/MyEsOrderBox';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MyClipBrandBlock = styled.div`

`;

const MyBrandBlock = styled.div`
    float: left;
    margin-top: 3px;
    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const MyBrandDropDownBlock = styled.div`
    float: right;
    vertical-align: baseline;
    
    ${isMobileOnly?`
    width:100px;
  `:`
    width:130px;
  `};
`;

const Options = [
    { value: 0, label: "최신순" },
    { value: 1, label: "가나다순" },
];

const MyBrandListUlBlock = styled.ul`
    ${isMobileOnly?`
    /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
    display: flex;
    /* -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap; */
    flex-wrap: wrap;
    margin-bottom: 40px;
    margin-left: 0px;
    /*  -webkit-box-pack: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between; */
    justify-content: space-between;
  `:`
    margin-left: -18px;
    margin-bottom: 40px;
  `};
`;

const MyBrandNoRequestItemLiBlock = styled.li`
    float: left;
    width: 214px;
    height: 210px;
    border-radius: 10px;
    text-align: center;
`;

const MyBrandNoRequestItemBlock = styled.a`
    
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    padding: 40px 20px;
    background-color: #ececec;
    border-radius: 10px;
    text-align: center;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
    transition: all 0.4s;
`;

const MyBrandNoRequestItemLogoPBlock = styled.p`
    margin-bottom: 8px;
`;

const MyBrandNoRequestItemImgBlock = styled.img`
    max-height: 28px;
`;
const MyBrandNoRequestItemTitleSpanBlock = styled.span`
    display: block;
    margin-bottom: 10px;
    font-size: 16px;
`;

const MyBrandNoRequestItemInfoPBlock = styled.p`
    line-height: 1.5;
    color: #333;
    font-size: 14px;
    font-weight: 400;
    text-align: left;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const DEFAULT_DISP_CNT = 12;
const MORE_DISP_CNT = 8;

const MyClipBrand = ({ clipinfo }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [openModal, setOpenModal] = useState(false);
    const [order, setOrder] = useState(0);
    const [submenu, setSubmenu] = useState(0);
    const [dispCnt, setDispCnt] = useState(DEFAULT_DISP_CNT);
    const [msg, setMsg] = useState(null);
    const [brandId, setBrandId] = useState(null);

    const { email } = useSelector(
        ({ userReducer }) => ({
            email: userReducer.id,
        })
    );


    const onChangeOrder = (param) => {
        setDispCnt(DEFAULT_DISP_CNT);
        setOrder(param.value);
        dispatch(userClipSortAction(param.value));
    }

    const handleClickMoreBtn = () => {

        let target = submenu === 0 ? clipinfo.brand : clipinfo.nobrand;

        let leftItem = target.length - dispCnt;

        if (leftItem < MORE_DISP_CNT) {
            setDispCnt(dispCnt + leftItem);
        } else {
            setDispCnt(dispCnt + MORE_DISP_CNT);
        }
    }

    const getNoContents = () => {
        if (submenu === 0) {
            return (
                <div className="none_item">
                    <span style={{width:'fit-content'}}>내가 클립한 브랜드가 없어요 :-(</span>
                </div>
            )
        } else {
            return (
                <div className="none_item">
                    <span style={{width:'fit-content'}}>내가 요청한 브랜드가 없어요 :-(</span>
                </div>
            )
        }
    }

    const getReqBtn = (entry_status) => {

        // console.log("entry_status : " + entry_status)
        if (entry_status === '080102') {
            return (<span className="mp_brand-btn mint-btn">신규오픈</span>)
        } else if (entry_status === '080103') {
            return (<span className="mp_brand-btn yellow-btn">오픈예정</span>)
        }

    }

    // 컨텐츠 정보
    const getBrandContents = (target) => {

        if (target.length === 0) {
            return getNoContents();
        } else {
            return (<div>
                <MyBrandListUlBlock className="mp_brand-list clearfix">
                    {
                        target.map((curitem, index) => {
                            if (index < dispCnt) {
                                return (
                                    <li key={curitem.id} style = {isMobileOnly? {width:'44vw', padding:"0px"}:{}}>
                                        {isMobileOnly ?
                                        <a>
                                            <div className="mp_brand-inner" onClick={() => { handleClickLogo(curitem.id) }}>
                                                <p className="mp-logo">
                                                    <img src={curitem.brnd_logo} alt="" style={{ height: '28px' }} />
                                                </p>
                                                <span>{curitem.brnd_nm}</span>
                                                {getReqBtn(curitem.entry_status)}
                                            </div>
                                            <button type="button" className="tag_s-delete pop_open"
                                                onClick={() => { handleClickDelBtn(curitem.id) }}></button>
                                        </a>
                                        :
                                        <a href="#">
                                            <div className="mp_brand-inner" onClick={() => { handleClickLogo(curitem.id) }}>
                                                <p className="mp-logo">
                                                    <img src={curitem.brnd_logo} alt="" style={{ height: '28px' }} />
                                                </p>
                                                <span>{curitem.brnd_nm}</span>
                                                {getReqBtn(curitem.entry_status)}
                                            </div>
                                            <button type="button" className="tag_s-delete pop_open"
                                                onClick={() => { handleClickDelBtn(curitem.id) }}></button>
                                        </a>
                                        }

                                    </li>
                                )
                            }
                        })
                    }
                    {isMobileOnly ? <li style={{height:'0px', margin: '0px'}}></li> : ''}
                </MyBrandListUlBlock>
                {
                    dispCnt >= target.length ? '' :
                        <div className="text_center">
                            <button className="underline-btn" onClick={handleClickMoreBtn}>더보기</button>
                        </div>
                }
            </div >)
        }
    }

    const getNoBrandContents = (target) => {

        if (target.length === 0) {
            return getNoContents();
        } else {
            return (<div>
                <MyBrandListUlBlock className="mp_brand-list clearfix">
                    {
                        target.map((curitem, index) => {
                            if (index < dispCnt) {
                                return (
                                    <MyBrandNoRequestItemLiBlock key = {curitem.id} style = {isMobileOnly? {width:'44vw', padding:"0px", height: '184px'}:{height: '184px'}}>
                                        <MyBrandNoRequestItemBlock>
                                            <MyBrandNoRequestItemLogoPBlock>
                                                <MyBrandNoRequestItemImgBlock src={curitem.brnd_logo}/>
                                            </MyBrandNoRequestItemLogoPBlock>
                                            <MyBrandNoRequestItemTitleSpanBlock>
                                            {curitem.brnd_nm}
                                            </MyBrandNoRequestItemTitleSpanBlock>

                                            <MyBrandNoRequestItemInfoPBlock>
                                            {curitem.no_brnd_info_brief}
                                            </MyBrandNoRequestItemInfoPBlock>

                                            <button type="button" className="tag_s-delete pop_open"
                                                    onClick={() => { handleClickDelBtn(curitem.id) }}></button>
                                        </MyBrandNoRequestItemBlock>
                                    </MyBrandNoRequestItemLiBlock>


                                )
                            }
                        })
                    }
                    {isMobileOnly ? <li style={{height:'0px', margin: '0px'}}></li> : ''}
                </MyBrandListUlBlock>
                {
                    dispCnt >= target.length ? '' :
                        <div className="text_center">
                            <button className="underline-btn" onClick={handleClickMoreBtn}>더보기</button>
                        </div>
                }
            </div >)
        }
    }

    const getContents = () => {

        if (clipinfo === null) {
            return getNoContents();
        } else if (submenu === 0) {
            return getBrandContents(clipinfo.brand);
        } else {
            return getNoBrandContents(clipinfo.nobrand);
        }
    }

    const getBrandCnt = () => {

        if (clipinfo === null || clipinfo.brand === null || clipinfo.brand === undefined) {
            return 0
        } else {
            return clipinfo.brand.length;
        }
    }

    const getNoBrandCnt = () => {
        if (clipinfo === null) {
            return 0
        } else {
            return clipinfo.nobrand.length;
        }
    }

    const handleSubmenuClick = (param) => {

        if (param !== submenu) {
            setOrder(0);
            setDispCnt(DEFAULT_DISP_CNT);
            setSubmenu(param);
            dispatch(userClipSortAction(0));
        }
    }

    const handleAllDelete = () => {
        setMsg("전체 삭제하시겠습니까?");
        // 팝업 표시
        setOpenModal(true);
    }

    // Delete 처리
    const handleClickDelBtn = (brandid) => {
        setMsg("삭제하시겠습니까?");
        setOpenModal(true);
        setBrandId(brandid);
    }

    const handleClickLogo = (brandid) => {
        if (submenu === 0) {
            history.push("/brHome/" + brandid);
        }
    }

    const handleModalClose = () => {
        setOpenModal(false);
    }

    // 확인
    const handleModalBtn1Click = () => {
        setOpenModal(false);
        if (msg === '삭제하시겠습니까?') {
            if (submenu === 0) {
                dispatch(setUserBrandDelAction(email, brandId));
            } else {
                dispatch(setUserNoBrandDelAction(email, brandId));
            }

        } else {
            if (submenu === 0) {
                dispatch(setUserBrandAllDelAction());
            } else {
                dispatch(setUserNoBrandAllDelAction());
            }
        }
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    return (
        <MyClipBrandBlock>
            {isMobileOnly ?
            <div>
                <div className="filter-top clearfix">
                    <ul className="tab-list f-left clearfix">
                        <li className={submenu === 0 ? "active" : ""} style = {{padding:'20px 5vw 20px 0px'}}>
                            <button type="button" className="green_border" onClick={() => { handleSubmenuClick(0) }}>
                                입점 브랜드 (<span>{getBrandCnt()}</span>)</button>
                        </li>
                        <li className={submenu === 1 ? "active" : ""} onClick={() => { handleSubmenuClick(1) }}
                        style = {isMobileOnly? {padding:'20px 2vw 20px 0px'}:{}} >
                            <button type="button" className="green_border">
                                요청 브랜드 (<span>{getNoBrandCnt()}</span>)</button>
                        </li>
                    </ul>
                </div>
                <div style = {{height:'30px'}}>
                    <div className="filter-fc f-right clearfix" style = {{padding:'0px'}}>
                        <button type="button" className="mp_text-btn f-left pop_open"
                            onClick={handleAllDelete}>전체삭제</button>

                        <MyBrandBlock>
                            <MyBrandDropDownBlock>
                            <div className="f-right clearfix">
                            <MyEsOrderBox
                                valueDefault={Options[order]}
                                options={Options}
                                onChange={onChangeOrder} 
                                height={'26px'}/>
                            </div>
                                {/* <SelectDropDownSmallBtn
                                    height='20px'
                                    valueDefault={Options[order]}
                                    options={Options}
                                    onChange={onChangeOrder} /> */}
                            </MyBrandDropDownBlock>
                        </MyBrandBlock>
                    </div>
                </div>
            </div>
            :
            <div className="filter-top clearfix">
                <ul className="tab-list f-left clearfix">
                    <li className={submenu === 0 ? "active" : ""}>
                        <button type="button" className="green_border" onClick={() => { handleSubmenuClick(0) }}>
                            입점 브랜드 (<span>{getBrandCnt()}</span>)</button>
                    </li>
                    <li className={submenu === 1 ? "active" : ""} onClick={() => { handleSubmenuClick(1) }}
                    style = {isMobileOnly? {padding:'20px 2vw 20px 0px'}:{}} >
                        <button type="button" className="green_border">
                            요청 브랜드 (<span>{getNoBrandCnt()}</span>)</button>
                    </li>
                </ul>

                <div className="filter-fc f-right clearfix">
                    <button type="button" className="mp_text-btn f-left pop_open"
                        onClick={handleAllDelete}>전체삭제</button>

                    <MyBrandBlock>
                        <MyBrandDropDownBlock>
                            <div className="f-right clearfix">
                            <MyEsOrderBox
                                valueDefault={Options[order]}
                                options={Options}
                                onChange={onChangeOrder} 
                                height={'26px'}/>
                            </div>
                            
                            {/* <SelectDropDownSmallBtn
                                height='20px'
                                valueDefault={Options[order]}
                                options={Options}
                                onChange={onChangeOrder} /> */}
                        </MyBrandDropDownBlock>
                    </MyBrandBlock>
                </div>
            </div>
            }

            {getContents()}
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    <NormalPopup
                        text=""
                        text2={msg}
                        btn1="확인" btn2="취소"
                        onClick1={handleModalBtn1Click}
                        onClick2={handleModalBtn2Click} />
                }

            </Modal>

        </MyClipBrandBlock>
    );
};

export default MyClipBrand;
